<script>
import _ from 'lodash';
import { wordLength } from 'utils/string';
/**
 * @module Basic Form组件标准内容
 */
export default {
  inject: {
    $formItem: {
      from: '$formItem',
      default: null
    },
    $form: {
      from: '$form',
      default: null
    }
  },
  /**
   * @prop {string} [label=''] - 标签
   * @prop {string} [placeholder=''] - 水印
   * @prop {string} [value=''] - 输入框等value
   * @prop {boolean} [error=false] - 是否错误状态
   * @prop {boolean} [disabled=false] - 是否禁用
   * @prop {string} [size=''] - 组件尺寸
   * @prop {string} [type=''] - 组件类型，参考标准html
   * @prop {boolean} [isAllowDisabledEvents=false] - 是否在禁用状态下仍可用
   * @prop {array} [options=[]] - 组件配置项
   * @prop {regexp} [countReg=/[\u4e00-\u9fa5]|[A-Za-z-]+|\S/g] - 计数正则
   * @prop {number} [max=300] - 计数时显示的最大数量
   * @prop {boolean} [multi=false] - radio group 使用，是否支持多选
   * @prop {boolean} [reverse=false] - radio group 使用，是否支持反选
   * @prop {function|null} [sort=() => {}] - 返回数据为array的组件使用，返回值是否排序
   */
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      default: 'normal'
    },
    skin: {
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    isAllowDisabledEvents: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    countReg: {
      type: RegExp,
      default: () => /[\u4e00-\u9fa5]|[A-Za-z-]+|\S/g
    },
    max: {
      type: Number,
      default: 300
    },
    multi: {
      type: Boolean,
      default: false
    },
    reverse: {
      type: Boolean,
      default: false
    },
    sort: {
      default: true
    }
  },
  computed: {
    /**
     * @description 是否有Form注入
     * @return {boolean}
     */
    extendFromForm() {
      return !!this.$form;
    },
    /**
     * @description 是否有FormItem注入
     * @return {boolean}
     */
    extendFromFormItem() {
      return !!this.$formItem;
    },
    /**
     * @description 组件通用class对象
     * @return {object}
     */
    componentClassObj() {
      let ret = {
        error: this.isError,
        disabled: this.disabled,
        focus: this.focus,
        formed: this.isFormed,
        'no-label': !this.label,
        'has-placeholder': !!this.placeholder
      };
      if (this.size) {
        ret[`size-${this.size}`] = true;
      }
      if (this.skin) {
        ret[`skin-${this.skin}`] = true;
      }
      if (this.type) {
        ret[`type-${this.type}`] = true;
      }
      return ret;
    },
    /**
     * @description 是否展示错误状态
     * @return {boolean}
     */
    isError() {
      if (this.extendFromFormItem) {
        return this.$formItem.isError;
      } else {
        return this.error;
      }
    },
    /**
     * @description 是否被填写
     * @return {boolean}
     */
    isFormed() {
      return this.value;
    },
    /**
     * @description value计数
     * @return {number}
     */
    count() {
      let ret = 0;
      if (_.isString(this.value)) {
        ret = wordLength(this.value, this.countReg);
      }
      return ret;
    }
  },
  /**
   * @member {boolean} focus - 组件是否聚焦
   */
  data: () => ({
    focus: false
  }),
  methods: {
    /**
     * @description 切换组件聚焦状态
     * @param {boolean} status 组件聚焦状态
     */
    triggerFocus(status) {
      let nextStatus = typeof status === 'boolean' ? status : !this.focus;
      // 如果nextStatus为true且this.disabled为false或者this.nextStatus为false
      if ((nextStatus && !this.disabled) || !this.nextStatus) {
        // 将this.focus设置为nextStatus
        this.focus = nextStatus;
        if (!this.focus) {
          this.setFormItemBlurred();
        }
      }
    },
    setFormItemBlurred() {
      if (this.extendFromFormItem) {
        this.$formItem.blurred = true;
      }
    }
  }
};
</script>
